export default {
  sentence: 'https://sanctions.nsplaw.com/sanctions',
  video: 'https://www.youtube.com/channel/UCuHMA6ZFJtYQpbfNAGPOKTQ',
  career: '/career',
  unlockingAssets: 'https://assets-unlocking.nsplaw.com',
  nationalization: 'https://nationalization.nsplaw.com',
  residencyInSpain: 'https://eu-residency.nsplaw.com',
};
